export const SHIRT_DEFAULT_MEASUREMENTS = {
  neck: 15,
  chest: 40,
  frontChestSplit: 10,
  waist: 36,
  frontWaistSplit: 9.375,
  belly: 38,
  frontBellySplit: 9.75,
  seat: 40,
  frontSeatSplit: 10,
  portlyType: 'normal',
  shoulder: 18,
  backShoulderSlope: 2,
  frontShoulderSlope: 2,
  backNeckDepth: 0.75,
  backToFtHps: 0.5,
  armholeScyeDepth: 8.25,
  acrossBack: 17,
  acrossFront: 16,
  xfDistanceFromChest: 2.5,
  distanceToWaist: 17.5,
  distanceToBelly: 21.5,
  shirtLengthBack: 31,
  tailDepthBack: 2,
  tailDepthFront: 2,
  tailDepth: 2,
  hemCurveMode: 1,
  dartWidthWaist: 1,
  dartWidthBelly: 0.5,
  dartLengthTop: 5,
  dartLengthBottom: 4,
  fishDartEnabled: true,

  backStyle: 'none',
  backPleatWidth: 0.75,
  backPleatLength: 3,
  backSidePleatOffsetFromBYDB: 0,

  yokeDepth: 3.5,
  yokeEnabled: true,
  frontNeckRollover: 1.25,
  frontArmholeRollover: 1.75,

  buttonExtensionWidth: 0.625,
  collarBandFrontNeckPercent: 30,
  collarBandBackHeight: 1.25,
  collarBandBackManual: 0,
  collarBandFrontHeight: 1,
  collarBandTopStartCtrlDx: 0,
  collarBandTopStartCtrlDy: 0,
  collarBandTopEndCtrlDx: 0,
  collarBandTopEndCtrlDy: 0,
  collarBandTopFollowBottom: 1,
  collarBandTopStartAbsX: 0,
  collarBandTopStartAbsY: 0,
  collarBandTopEndAbsX: 0,
  collarBandTopEndAbsY: 0,
  collarBandBottomStartCtrlDx: 0,
  collarBandBottomStartCtrlDy: 0,
  collarBandBottomEndCtrlDx: 0,
  collarBandBottomEndCtrlDy: 0,
  collarBandNeckCtrlDx: 0,
  collarBandNeckCtrlDy: 0,
  collarLeafBackHeight: 1.75,
  collarLeafTieGap: 1,
  collarLeafPointLength: 3,
  collarLeafSpread: 0,
  collarLeafTopStartCtrlDx: 0,
  collarLeafTopStartCtrlDy: 0,
  collarLeafTopEndCtrlDx: 0,
  collarLeafTopEndCtrlDy: 0,
  placketFoldWidth: 1.25,
  buttonCount: 0,
  firstButtonPosition: 2,
  lastButtonPosition: 3.5,

  yokeDartWidth: 0.75,
  yokeDartLength: 4,
  yokeDartYokeCtrlDx: 0,
  yokeDartYokeCtrlDy: 0.125,
  yokeDartBackCtrlDx: 0,
  yokeDartBackCtrlDy: 0,
  backYokeArmSplitCtrlDx: 0,
  backYokeArmSplitCtrlDy: 0,
  backPanelYokeSplitCtrlDx: 0,
  backPanelYokeSplitCtrlDy: 0,

  backNeckCtrlDx: 0,
  backNeckCtrlDy: 0,
  frontNeckCtrlDx: 0,
  frontNeckCtrlDy: 0,
  backArmPart1CtrlDx: 0,
  backArmPart1CtrlDy: 0,
  backArmPart2CtrlDx: 0,
  backArmPart2CtrlDy: 0,
  frontArmPart1CtrlDx: 0,
  frontArmPart1CtrlDy: 0,
  frontArmPart2CtrlDx: 0,
  frontArmPart2CtrlDy: 0,
  backHemCtrl1Dx: 0,
  backHemCtrl1Dy: 0,
  backHemCtrl2Dx: 0,
  backHemCtrl2Dy: 0,
  frontHemCtrl1Dx: 0,
  frontHemCtrl1Dy: 0,
  frontHemCtrl2Dx: 0,
  frontHemCtrl2Dy: 0,
  frontChestWaistCtrlDx: 0,
  frontChestWaistCtrlDy: 0,
  frontWaistBellyCtrlDx: 0,
  frontWaistBellyCtrlDy: 0,
  frontBellySeatCtrlDx: 0,
  frontBellySeatCtrlDy: 0,
  backChestWaistCtrlDx: 0,
  backChestWaistCtrlDy: 0,
  backWaistBellyCtrlDx: 0,
  backWaistBellyCtrlDy: 0,
  backBellySeatCtrlDx: 0,
  backBellySeatCtrlDy: 0,
  sideSeamAutoDepth: 1.625,

  overrideFNWEnabled: false,
  overrideBNWEnabled: false,
  overrideFNDEnabled: false,
  overrideBNDEnabled: false,
  overrideFNW: 2.625,
  overrideBNW: 2.625,
  overrideFND: 3.125,
  overrideBND: 0.75,

  overrideAcrossBackDepthEnabled: false,
  overrideAcrossFrontDepthEnabled: false,
  overrideAcrossBackDepth: 3.75,
  overrideAcrossFrontDepth: 4,

  bicepWidth: 15.5,
  sleeveStyle: 'long',
  elbowWidth: 13.5,
  sleeveDistToElbow: 0,
  maxCuffWidth: 11,
  cuffWidth: 2.5,
  sleeveLength: 26,
  shortSleeveHem: 11,
  shortSleeveLength: 10,
  sleeveFrontPitchPercent: 0.6,
  sleeveBackPitchPercent: 0.4,

  sleeveFrontUnderarmCtrlDx: -1.75,
  sleeveFrontUnderarmCtrlDy: 0.625,
  sleeveFrontCrownCtrlDx: 2.375,
  sleeveFrontCrownCtrlDy: 0,
  sleeveBackCrownCtrlDx: -2.25,
  sleeveBackCrownCtrlDy: -0.25,
  sleeveBackUnderarmCtrlDx: 2.5,
  sleeveBackUnderarmCtrlDy: 0.5,
  sleeveFrontSideUpperCtrlDx: 0,
  sleeveFrontSideUpperCtrlDy: 0,
  sleeveFrontSideLowerCtrlDx: 0,
  sleeveFrontSideLowerCtrlDy: 0,
  sleeveBackSideUpperCtrlDx: 0,
  sleeveBackSideUpperCtrlDy: 0,
  sleeveBackSideLowerCtrlDx: 0,
  sleeveBackSideLowerCtrlDy: 0,
};
